export default __webpack_public_path__ + "static/media/odlicno_negativ.0cc369ec.svg";